import {LOAD_USER_DATA, DELETE_A_USER, SAVE_A_USER, UPDATE_A_USER, CLEAR_A_USER_ERROR_MESSAGE} from './actions';


const initialState = {
  usersArray:[],
    deleteUserResp:{},
    errorCMsg:{},
    saveUserResp:{},
    updateUserResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_USER_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
    case LOAD_USER_DATA:
        console.log("LOAD_USER_DATA data1");
        //console.log(action.usersData[0])
        console.log("LOAD_USER_DATA data2");
        //console.log(action.usersData)
          return Object.assign({}, state, {
              usersArray: action.usersData,
              saveUserResp:action.usersData
          });
          case DELETE_A_USER:
          return Object.assign({}, state, {
              deleteUserResp: action.deleteUserResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_USER:
        console.log("SAVE_A_USER");
        //console.log(action.saveUserResponse)
          return Object.assign({}, state, {
              saveUserResp: action.saveUserResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_USER:
        console.log("UPDATE_A_USER");
        //console.log(action.saveUserResponse);
          return Object.assign({}, state, {
              saveUserResp: action.saveUserResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
